let Topsites_Preview;

Topsites_Preview = (() => {
    function Topsites_Preview() {
        if (window.navigator && window.navigator.loadPurpose === "preview") {
            window.location.href = `${window.location.origin}/topsites-preview/`;
        }
    }

    return Topsites_Preview;
})();

export default new Topsites_Preview();
